import { apiV2 } from "../axiosInstance";

function getVendors() {
    return apiV2.get(`vendors`);
};

export { getVendors }